<template>
  <div class="cas-page-container">
    <div class="body">
      <div class="title">
        {{ $t(`message.connectingPleaseWait`) }}
      </div>
      <div
        class="spinner-border"
        role="status"
        v-if="$store.getters['loadings/isLoading']"
      >
        <span class="visually-hidden">{{ $t(`message.loading`) }}...</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "GarResourceCas",
  mounted() {
    this.$store.dispatch("loadings/enableLoadings");
    // In case of resource/ticket
    if ("ticket" in this.$route.query) {
      const query = this.$route.query;
      this.$store
        .dispatch("garResource/getGarResourceTicket", query)
        .then((credentials) => {
          this.$store
            .dispatch("users/login", credentials)
            .then(() => {
              localStorage.setItem("display-subscribe-popup", true);
              this.$router.push({ name: "PersonalHome" });
            })
            .catch(() => {
              console.log("AppLogin dispatch catch error");
            })
            .finally(() => {
              this.$store.dispatch("loadings/disableLoadings");
            });
        });
    } else {
      this.$store.dispatch("users/logout");
      this.$store.dispatch("garResource/getGarResource");
      this.$store.dispatch("loadings/disableLoadings");
    }
  },
};
</script>

<style lang="scss" scoped>
.cas-page-container {
  display: flex;
  justify-content: center;
  min-height: calc(100vh - 100px - 126px - 40px);

  .body {
    display: flex;
    align-items: center;
    flex-direction: column;
    background-color: #a2c0e2;
    border-radius: 50px;
    width: 90%;
    padding: 40px 20px 20px 20px;
    min-height: 400px;
    margin-bottom: 40px;

    .title {
      text-transform: uppercase;
      font-weight: bold;
      font-size: 1.3em;
      text-align: center;
      letter-spacing: 0.1rem;
      margin-bottom: 2rem;
    }
  }
}
</style>
